<template>
  <div>
    <crumb-tit>
      <span slot="breadTit">Webhook</span>
      <span slot="secondTit">Webhook</span>
    </crumb-tit>
    <div class="webhook-tip-t">
      <a-alert
        message="借助Webhook功能可以将星轨询盘管理上的一些事件推送至其他系统中，比如企业微信的群机器人。"
        type="info"
        show-icon
      />
    </div>
    <div class="webhook-view">
      <router-view />
    </div>
  </div>
</template>
<script>
import CrumbTit from '@/components/pc/config/CrumbTit'
export default {
  components: {
    CrumbTit
  }
}
</script>

<style lang="scss" scoped>
  .webhook-tip-t::v-deep {
    margin: 16px 0;
    .ant-alert-info{
      border-color:#4CA0F2 ;
      background: #DBEDFF;
    }
  }
</style>
